import { useQuery } from "react-query";
import { getUserPartnerInformation } from "../services/users/users.api";

export function useUserPartnerInformation(uid?: string | null) {
  const { data: userPartnerInformation, ...rest } = useQuery(
    ["userPartnerInformation", uid],
    () => getUserPartnerInformation(uid),
    { enabled: !!uid }
  );

  return { userPartnerInformation, ...rest };
}
